/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { Button, message, Modal } from 'antd';
import { hashHistory } from 'react-router';
import { DmsTab, TableView, RemarkModal } from 'Components';
import { getList, deleteRemarks } from '../../service/remark/remark';
const confirm = Modal.confirm;

class RemarkList extends React.Component {
  constructor (props) {
    super(props);
    const entityId = parseInt(this.props.location.query.entityId, 10);
    const entityType = this.props.location.query.entityType;
    let dealType = '';
    switch (entityType){//1-渠道；2-渠道联系人；3-门店；4-门店店员
      case 'channel':
        dealType = 1;
        break;
      case 'linkman':
        dealType= 2;
        break;
      case 'store':
        dealType = 3;
        break;
      case 'staff':
        dealType = 4;
        break;
      default:
        break;
    }
    this.state = {
      //filterBoxVisible: false,
      entityId,
      entityType,
      rows: [],
      editData: null,
      isEdit: false,
      total: 0,
      searchObj: {
        relatedTableType: dealType,
        relatedTableId: entityId,
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.editDone = this.editDone.bind(this);
    this.openModal = this.openModal.bind(this);
    this.editRemark = this.editRemark.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.deleteRemark = this.deleteRemark.bind(this);
  }
  componentDidMount() {
    this.getData();
  }
  openModal() {
    this.remarkModal.showModal();
  }

  getData () {
    const self = this;
    const {searchObj} = this.state;
    getList(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data});
      }else{
        console.error(res.message);
      }
    });
  }

  editRemark(index){
    const self = this;
    this.setState({
      editData: this.state.rows[index],
      isEdit: true,
    }, () => {
      self.openModal();
    })
  }
  editDone(){
    const self = this;
    this.setState({
      editData: null,
      isEdit: false,
    }, () => {
      self.getData();
    })
  }

  deleteRemark (id) {
    const self = this;
    confirm({
      title: '确定要删除这条记录?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteRemarks({ id }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getData();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  goBack () {
    hashHistory.goBack();
  }

  goView (url) {
    hashHistory.push(url);
  }

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }

  render () {
    const self = this;
    const { rows, total, searchObj, entityType, entityId, editData, isEdit } = this.state;
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '主题',
          dataIndex: 'content',
          width: '70%'
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index ) => <span>
            <a onClick={self.editRemark.bind(self, index)}>编辑</a>&nbsp;&nbsp;&nbsp;&nbsp;
            <a onClick={self.deleteRemark.bind(self, record.id)}>删除</a>
          </span>
        },
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['全部备注']} defaultKey={0}>
        <Button icon="plus" onClick={this.openModal.bind(this)}>新建备注</Button>
        <Button onClick={this.goBack}>返回</Button>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>

      <RemarkModal ref={(node) => { this.remarkModal = node; }}
                   entityType={entityType}
                   entityId={entityId}
                   isEdit={isEdit}
                   editData={editData}
                   onEditDone={this.editDone}
                   onSuccess={this.getData}/>
    </div>
  }
}
;
export default RemarkList;


// WEBPACK FOOTER //
// ./src/routes/remark/remark.js